import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useEduCourseExtendedInformation(courseDetail) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!courseDetail) return [];
    const beforeLinkRaw = (courseDetail.before_course_link || '').trim();
    const afterLinkRaw = (courseDetail.after_course_link || '').trim();

    return [
      {
        label: t('Akreditácia kurzu'),
        value: courseDetail.accreditation,
      },
      {
        label: t('Kľúčové slová'),
        value: courseDetail.keywords,
      },
      {
        label: t('Odporúčaný kurz pred (link)'),
        value: beforeLinkRaw
          ? `<a href="${beforeLinkRaw}" target="_blank" rel="noopener noreferrer">${beforeLinkRaw}</a>`
          : '',
        isRaw: true,
      },
      {
        label: t('Odporúčaný kurz po (link)'),
        value: afterLinkRaw
          ? `<a href="${afterLinkRaw}" target="_blank" rel="noopener noreferrer">${afterLinkRaw}</a>`
          : '',
        isRaw: true,
      },
      {
        label: t('Cieľová skupina'),
        value: courseDetail.target_group,
      },
      {
        label: t('Poznámky'),
        value: courseDetail.notes,
        isRaw: true,
      },
    ];
  }, [courseDetail, t]);
}
